// extracted by mini-css-extract-plugin
module.exports = {"doc":"document-module_doc_2Btjc","xs":"document-module_xs_29BPN","sm":"document-module_sm_2YmNH"};